import { DioboxEvent } from "sharedTypes"

export type PortalColors = Pick<
  DioboxEvent,
  "portalPrimaryColor" | "portalTopNavBackgroundColor" | "portalTopNavTextColor" | "portalBackgroundColor"
>

export const PORTAL_COLOR_FIELDS: { key: keyof PortalColors, label: string }[] = [
  { key: "portalPrimaryColor", label: "Primary Color" },
  { key: "portalTopNavBackgroundColor", label: "Top Nav Background" },
  { key: "portalTopNavTextColor", label: "Top Nav Text" },
  { key: "portalBackgroundColor", label: "Page Background" },
]

export const COLOR_THEMES: { name: string, colors: PortalColors }[] = [
  {
    name: "Default",
    colors: {
      portalPrimaryColor: "#4A90E2",
      portalTopNavBackgroundColor: "#F9F9F9",
      portalTopNavTextColor: "#000000",
      portalBackgroundColor: "#F9F9F9",
    },
  },
  {
    name: "Neutral",
    colors: {
      portalPrimaryColor: "#4D85BA",
      portalTopNavBackgroundColor: "#F0ECE9",
      portalTopNavTextColor: "#695845",
      portalBackgroundColor: "#F6F4F2",
    },
  },
  {
    name: "Lapis",
    colors: {
      portalPrimaryColor: "#1163C4",
      portalTopNavBackgroundColor: "#1163C4",
      portalTopNavTextColor: "#FFFFFF",
      portalBackgroundColor: "#F9F9F9",
    },
  },
  {
    name: "Flix",
    colors: {
      portalPrimaryColor: "#F20000",
      portalTopNavBackgroundColor: "#00162C",
      portalTopNavTextColor: "#FFFFFF",
      portalBackgroundColor: "#F9F9F9",
    },
  },
  {
    name: "Onyx",
    colors: {
      portalPrimaryColor: "#3182CE",
      portalTopNavBackgroundColor: "#141A16",
      portalTopNavTextColor: "#FFFFFF",
      portalBackgroundColor: "#141A16",
    },
  },
]

export const CUSTOM_THEME_NAME = "Custom"

export const pickPortalColors = (event: PortalColors): PortalColors => ({
  portalPrimaryColor: event.portalPrimaryColor,
  portalTopNavBackgroundColor: event.portalTopNavBackgroundColor,
  portalTopNavTextColor: event.portalTopNavTextColor,
  portalBackgroundColor: event.portalBackgroundColor,
})

export const sameColors = (a: PortalColors, b: PortalColors) => PORTAL_COLOR_FIELDS.every(
  ({ key }) => a[key]?.toLowerCase() === b[key]?.toLowerCase(),
)

export const themeNameFor = (colors: PortalColors) => (
  COLOR_THEMES.find((theme) => sameColors(theme.colors, colors))?.name ?? CUSTOM_THEME_NAME
)
